import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, RefreshCw } from "lucide-react";
import { generateRecap } from "@/lib/api";
import { formatTime } from "@/lib/format";

export default function RecapPanel({ recaps, onRefresh, spectator }) {
  const [generating, setGenerating] = useState(false);
  const latest = recaps && recaps.length ? recaps[0] : null;

  const handleGenerate = async () => {
    if (spectator || generating) return;
    setGenerating(true);
    toast.info("Claude is writing the recap…");
    try {
      await generateRecap();
      await onRefresh?.();
      toast.success("Fresh recap ready.");
    } catch (e) {
      toast.error("Couldn't generate recap.");
      console.error(e);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <section data-testid="recap-panel" className="border border-arena-line bg-white">
      <div className="px-6 lg:px-8 py-4 border-b border-arena-line flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <Sparkles size={16} className="text-ai-claude" />
          <h2 className="font-display font-black text-2xl tracking-tighter">RECAP</h2>
          {latest && (
            <span className="text-[10px] font-mono uppercase tracking-[0.25em] text-arena-soft">
              Day {latest.day_number} · {formatTime(latest.timestamp)}
            </span>
          )}
        </div>
        {!spectator && (
          <button
            data-testid="recap-generate-btn"
            onClick={handleGenerate}
            disabled={generating}
            className="flex items-center gap-2 rounded-none border border-arena-line bg-white text-arena-ink hover:bg-arena-alt font-bold uppercase tracking-[0.2em] text-[10px] py-2 px-4 transition-colors disabled:opacity-50"
          >
            <RefreshCw size={12} className={generating ? "animate-spin" : ""} />
            {generating ? "Writing…" : "Refresh"}
          </button>
        )}
      </div>
      <div className="px-6 lg:px-8 py-6">
        {latest ? (
          <p className="text-sm lg:text-base text-arena-ink leading-relaxed font-ui">
            {latest.text}
          </p>
        ) : (
          <p className="text-sm text-arena-soft font-mono">
            No recap yet — recaps auto-generate every 12 hours, or click Refresh.
          </p>
        )}
      </div>
    </section>
  );
}
